module.exports = __webpack_public_path__ + "static/img/040_5.e12ad88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_5.jpg
// module id = bvdf
// module chunks = 1